
export * from './modal-edit-products-properties.module'
export * from './modal-edit-products-properties.component'
